// extracted by mini-css-extract-plugin
export var formSection = "styles-module__formSection___kWwML";
export var textInputSpacer = "styles-module__textInputSpacer____vLRS";
export var labelName = "styles-module__labelName___NrSuP";
export var alignedLabel = "styles-module__alignedLabel___tiHSB";
export var dropdowns = "styles-module__dropdowns___X3Axh";
export var spaceBetween = "styles-module__spaceBetween___a8O9C";
export var starRatingIconClass = "styles-module__starRatingIconClass___tUfNx";
export var privacyContainer = "styles-module__privacyContainer___haKar";
export var starsContainer = "styles-module__starsContainer___VI809";
export var topField = "styles-module__topField___ZxMRs";
export var nearbyTrailsContainer = "styles-module__nearbyTrailsContainer___wFyvd";
export var trailDropdown = "styles-module__trailDropdown___BHDmH";
export var textArea = "styles-module__textArea___q5hoA";
export var muiInputRoot = "styles-module__MuiInput-root___t7x7v";